import axios from "axios";

export const listLaunch = (data) => axios('missions/launches/history/', { params: data });

export const listLaunchSite = (data) => axios('missions/launchsites/', { params: data });

export const getLaunchStatistics = (data) => axios('missions/launches/statsv2/', { params: data });
